import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {
  approveTokens,
  deposit,
  getAllowance, 
} from '../../helpers';
import SelectForm from './SelectForm';
import ApproveForm from './ApproveForm';
import ConfirmForm from './ConfirmForm';
import ResultForm from './ResultForm';

const Swap = ({ address, token, cancel }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [swapState, setSwapState] = useState(0);
  const [swapInfo, setSwapInfo] = useState({}); 

  const handleApprove = async () => {
    const response = await approveTokens(
      swapInfo.token.address,
      swapInfo.amounts.sell
    );
    snackMessage(response.message, response.success ? 'success' : 'warning');
    return response;
  };

  const handleChangeSwapState = (state) => {
    setSwapState(state);
  };

  const handleEditSwapInfo = (info) => {
    setSwapInfo({...swapInfo, ...info});
  };
 

  const handleGetAllowance = async (token, amounts, updateSwapState) => {
    const response = await getAllowance(token.address, address);
    if (response.success) {
      setSwapInfo({
        ...swapInfo,
        token,
        amounts: amounts,
        allowance: response.allowance,
        fee: response.fee,
        symbol: response.symbol,
      });
      if (updateSwapState) {
        if (parseFloat(response.allowance) >= parseFloat(amounts.sell)) {
           setSwapState(2);
        } else {
           setSwapState(1);
        }
      }
    } else {
      snackMessage(response.message, 'warning');
    }
    return response;
  };

  const handleConfirm = async () => {
    const response = await deposit(
      swapInfo.token.address,
      swapInfo.amounts.sell
    );
    if (response.success && response.hash) {
      snackMessage('Transaction sent!', 'success');
      setSwapInfo({ ...swapInfo, hash: response.hash });
      setSwapState(3);
    } else {
      snackMessage(response.message, 'warning');
    }
    return response;
  };

  const snackMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
    setTimeout(() => {
      closeSnackbar();
    }, 5000);
  };

 

  return (
    <div>
      <div className="container">
        <div className="row">
          <Tabs>
            <TabPanel style={{ marginLeft: '10%', marginBottom: 30 }}>
              <div className="content-inner">
                {swapState == 0 && (
                  <SelectForm
                    allowance={handleGetAllowance}
                    token={token}
                    cancel={cancel}
                    userAddress={address} 
                    editSwapInfo={handleEditSwapInfo}
                  />
                )}
                {swapState == 1 && (
                  <ApproveForm
                    approve={handleApprove}
                    swapInfo={swapInfo}
                    snackMessage={snackMessage}
                    changeState={handleChangeSwapState}
                    userAddress={address}
                    cancel={cancel}
                  />
                )}
                {swapState == 2 && (
                  <ConfirmForm
                    confirm={handleConfirm}
                    swapInfo={swapInfo}
                    cancel={cancel}
                  />
                )}
                {swapState == 3 && (
                  <ResultForm
                    swapInfo={swapInfo}
                    close={cancel}
                    success={true}
                  />
                )}
              </div>
            </TabPanel>

            <TabPanel></TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Swap;
